"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _classnames = _interopRequireDefault(require("classnames"));

var _useStyles = require("../../../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children"];
(0, _loadStyles.default)(".c9e0c88db{width:.625rem;height:.625rem;background:#fff;border-radius:.0625rem;position:absolute;-webkit-transform:rotate(45deg);transform:rotate(45deg);z-index:1;left:1rem}.c2692b63f{bottom:-.3rem}.cfdcc6096{top:-.3rem}");
var styles = {
  arrow: 'c9e0c88db',
  '--placement-top': 'c2692b63f',
  '--placement-bottom': 'cfdcc6096'
};
var AMenu = _reactSelect.components.Menu;
/* applying dropdown styles to menu */

var Menu = function Menu(props) {
  // eslint-disable-next-line
  var children = props.children,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, {});
  var menuPlacement = rest.menuPlacement,
      placement = rest.placement;
  return /*#__PURE__*/_react.default.createElement(AMenu, rest, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.arrow, cn.placement[menuPlacement !== 'auto' ? menuPlacement : placement])
  }), children);
};

exports.Menu = Menu;